/* SHEESH Exit Offer - staging, no third-party dependency. */
(function () {
  'use strict';
  var OFFER = '/pages/einmaliges-angebot';
  var KEY = 'sheesh_exit_offer_shown_until_v1';
  var params = new URLSearchParams(window.location.search);
  var testing = params.get('sheesh_exit_test') === '1';
  var path = window.location.pathname;
  if (/^\/(?:checkout|checkouts|cart|account|policies|password)(?:\/|$)/i.test(path) ||
      /^\/pages\/(?:einmaliges-angebot|dein-10-prozent-angebot)(?:\/|$)/i.test(path) ||
      /\/challenge(?:\/|$)/i.test(path) || window.Shopify && window.Shopify.designMode && !testing) return;
  try { if (!testing && Date.now() < Number(localStorage.getItem(KEY) || 0)) return; } catch (e) {}
  var enabledAt = Date.now() + (testing ? 1000 : 5000);
  var shown = false, pagesVisited = 1, eligible = testing;
  try {
    var prev = sessionStorage.getItem('sheesh_exit_pages_v1');
    pagesVisited = Math.min(50, Number(prev || 0) + 1);
    sessionStorage.setItem('sheesh_exit_pages_v1', String(pagesVisited));
    eligible = testing || pagesVisited >= 2;
  } catch(e) { eligible = testing; }
  function show() {
    if (shown || !eligible || Date.now() < enabledAt) return false;
    shown = true;
    try { localStorage.setItem(KEY, String(Date.now() + 7 * 24 * 60 * 60 * 1000)); } catch(e) {}
    window.location.assign(OFFER);
    return true;
  }
  // Desktop exit intent: only an upward exit through the browser's top edge.
  if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.toElement) return;
      if (e.clientY <= 12) show();
    }, {passive:true});
  } else {
    // Mobile: one back-navigation interception, preserving the preceding history entry.
    if (eligible && window.history && history.pushState) {
      try {
        history.pushState({sheeshExitOffer:true}, '', location.href);
        window.addEventListener('popstate', function () {
          if (shown || Date.now() < enabledAt) return;
          show();
        }, {once:true});
      } catch(e) {}
    }
  }
})();
